<template>
    <ReceiptLogs
        v-if="!receiptLogDetailMasterListEnabled"
        :receipt-logs="receiptLogs"
        :total="total"
        :route-query="searchQuery"
        :exclude-available-when-zero="excludeAvailableWhenZero"
        :excluded-columns="excludedColumns"
        :current-page="currentPage"
        :per-page="receiptLogsPerPage"
        @perPageUpdated="setReceiptLogsPerPage($event)"
        @changedPage="changedPage"
        @search="onSearch"
        @changeExcludeAvailableWhenZero="changeExcludeAvailableWhenZero"
        @requestDelivery="requestDelivery"
    />
</template>
<script>
import { mapState, mapActions } from "vuex";
import ReceiptLogs from "./_components/ReceiptLogs.vue";
import { store, getters, mutations } from "src/global-store.js";

export default {
    name: "ReceiptLogsModule",
    components: {
        ReceiptLogs,
    },
    data() {
        return {
            pageInfo: {},
            searchQuery: null,
            searchLimit: 100,
            searchOffset: 0,
            currentPage: 1,
            excludeAvailableWhenZero: true,
            unitSelection: [],
            receiptLogDetailMasterList: JSON.parse(
                localStorage.getItem("settings_receiptlogdetailmasterlist") ??
                    "false",
            ),
        };
    },
    computed: {
        me() {
            return store.me;
        },
        receiptLogDetailMasterListEnabled() {
            // TODO: this is only to prevent a company role from
            // hitting the unit master list because the performance is bad
            // We can remove this check once we implement paging
            // for the All Receipt Log Units view
            if (this.hasCompanyRole) {
                return false;
            }
            return this.receiptLogDetailMasterList;
        },
        isCustomer() {
            return getters.isCustomer();
        },
        isDesigner() {
            return getters.isDesigner();
        },
        hasCompanyRole() {
            return getters.hasCompanyRole();
        },
        ...mapState("receiptLog", {
            receiptLogs: (state) => state.receiptLogs,
            total: (state) => state.total,
            receiptLogsPerPage: (state) => state.receiptLogsPerPage,
        }),
        excludedColumns() {
            const columns = [];
            if (this.isCustomer) columns.push("Customer");
            if (this.isDesigner) columns.push("Designer");
            const some = this.receiptLogs
                .map((r) => r.designer?.fullName)
                .filter((r) => r != null);
            if (some.length == 0) {
                columns.push("Designer");
            }
            return columns;
        },
    },
    watch: {
        searchQuery() {
            this.updateRouterQuery();
        },
        currentPage() {
            this.updateRouterQuery();
        },
        excludeAvailableWhenZero() {
            this.updateRouterQuery();
        },
        "me.customer_name": function () {
            mutations.setNavbarTitle("Receipt Logs", this.me?.customer_name);
        },
    },
    created() {
        if (this.receiptLogDetailMasterListEnabled) {
            this.$router.push("/receipts/units");
        } else {
            this.searchQuery = this.$route.query.q;
            if (this.$route.query.p) {
                this.currentPage = parseInt(this.$route.query.p, 10);
                // change search limit to account for page number
                const itemsNeeded = this.currentPage * this.perPage;
                this.searchLimit = itemsNeeded <= 50 ? 100 : itemsNeeded + 50;
            }
            if (this.$route.query.e) {
                this.excludeAvailableWhenZero = this.$route.query.e === "true";
            }
            this.fetchReceipts();
            // reset search limit
            this.searchLimit = 100;
        }
        mutations.setNavbarTitle("Receipt Logs", this.me?.customer_name);
    },
    methods: {
        ...mapActions("receiptLog", [
            "fetchReceiptLogs",
            "setReceiptLogsPerPage",
        ]),
        ...mapActions("deliveryRequest", ["addToPendingReceiptLogs"]),
        async fetchReceipts() {
            const data = await this.fetchReceiptLogs({
                limit: this.searchLimit,
                offset: this.searchOffset,
                search: this.searchQuery,
                excludeAvailableWhenZero: this.excludeAvailableWhenZero,
            });
            this.pageInfo = data.pageInfo;
            this.searchOffset = this.pageInfo.cursor;
        },
        async fetchMore() {
            if (this.pageInfo.hasNextPage) {
                await this.fetchReceipts();
                this.searchOffset = this.pageInfo.cursor;
            }
        },
        changedPage(newPage) {
            if (this.currentPage !== newPage) {
                this.currentPage = newPage;
                const totalItems = this.receiptLogs.length;
                const visibleItemCount = newPage * this.receiptLogsPerPage;

                if (totalItems - visibleItemCount <= this.searchLimit / 2) {
                    this.fetchMore();
                }
            }
        },
        async changeExcludeAvailableWhenZero(value) {
            this.excludeAvailableWhenZero = value;
            this.searchOffset = 0;
            await this.fetchReceipts();
        },
        async onSearch(query) {
            this.searchQuery = query;
            this.searchOffset = 0;

            await this.fetchReceipts();
            // reset page to 1 with every new search
            this.currentPage = 1;
        },
        updateRouterQuery() {
            // update the window's search query url
            const query = {
                q: this.searchQuery,
                p: this.currentPage,
                e: this.excludeAvailableWhenZero,
            };
            if (!this.searchQuery) delete query.q;
            if (!this.currentPage || this.currentPage === 1) delete query.p;
            if (this.excludeAvailableWhenZero !== false) delete query.e;

            this.$router
                .replace({
                    name: "Receipt Logs",
                    query,
                })
                .catch(() => {});
        },
        requestDelivery(selectedReceiptLogs) {
            this.addToPendingReceiptLogs({
                receiptLogs: selectedReceiptLogs,
            });
        },
    },
};
</script>
